import React from 'react';
import { LIFECYCLE_COLORS } from '../types/playbook.types';
import type { PlaybookLifecycle } from '../types/playbook.types';

interface LifecycleBadgeProps {
  lifecycle: PlaybookLifecycle;
}

const LifecycleBadge: React.FC<LifecycleBadgeProps> = ({ lifecycle }) => {
  const colors = LIFECYCLE_COLORS[lifecycle] || LIFECYCLE_COLORS.draft;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${colors.bg} ${colors.text} ${colors.darkBg} ${colors.darkText}`}
    >
      {lifecycle.replace('_', ' ')}
    </span>
  );
};

export default LifecycleBadge;
